export const appActionPresentationSummaryMapper = {
  key: 'presentationSummaryMapper',
  type: 'app',
  label: 'Summary Mapping',
  description: 'Define code used to craft operation summaries from action request and response data.',
  path: 'actions[id:{{actionId}}].presentation.summaryMapper.code',
  shouldRun: ({ changes }) => {
    const paths = ['presentation.summaryMapper', 'meta.lastRunOn'];
    return changes?.some((change) => paths.some((path) => change?.path?.includes(path)));
  },
  context: ['appActionOutput'],
  mapContext: ({ app, action, appActionOutput }) => ({
    appName: app?.name,
    name: action?.name,
    currentValue: action?.presentation?.summaryMapper?.code || '',
    actionDetails: {
      model: action?.model,
      operation: action?.operation || 'none',
      slug: action?.slug,
      name: action?.name,
      method: action?.api?.method
    },
    appActionOutput
  }),
  formatLabel: (value) => (value ? 'Configured' : 'Not configured'),
  prompt: 'appActionPresentationSummaryMapper'
};
